import { createFileRoute } from "@tanstack/react-router";
import { AuditPage } from "@/components/audit/AuditPage";
import { auditHead } from "@/components/audit/auditHead";

export const Route = createFileRoute("/audit")({
  head: auditHead,
  component: AuditPage,
});
